var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:[_vm.asset, _vm.size, _vm.aspectRatio],attrs:{"draggable":false,"src":_vm.assetUrl,"alt":"asset"}})}
var staticRenderFns = []

export { render, staticRenderFns }